<template>
  <div
    class="placeholder"
    :style="{
      height: totalHeight
    }"
  >
    <div
      class="content"
      :class="{ 'content-fixed': fixed }"
      :style="{
        backgroundColor: options.barBackgroundColor || '#fff',
        zIndex: zIndex
      }"
    >
      <div class="status-bar" :style="{ height: statusBarHeight + 'px' }"></div>
      <div
        class="nav"
        :style="{ height: showTabBar ? tabBarHeight + 'px' : '0px' }"
      >
        <div class="nav-bar-left" v-if="back" @click="bindBack">
          <div
            class="back iconfont icon-fanhui"
            :style="{ color: options.color || '#000' }"
          ></div>
          <slot name="left"></slot>
        </div>
        <div
          class="nav-bar-title"
          :style="{
            color: options.color || '#000',
            fontSize: options.fontSize || '4.8vw',
            textAlign: options.textAlign || 'center'
          }"
        >
          {{ title }}
        </div>
        <div
          class="nav-bar-right"
          @click="bindRight"
          :style="{ color: options.color || '#000' }"
        >
          <slot name="right"></slot>
        </div>
      </div>
      <slot name="nav"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    zIndex: {
      type: Number,
      default: 1
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    //是否占用位置
    placeholder: {
      type: Boolean,
      default: false
    },
    //是否固定在顶部
    fixed: {
      type: Boolean,
      default: true
    },
    //标题
    title: {
      type: String,
      default: ''
    },
    //左边的文字
    leftText: {
      type: String,
      default: ''
    },
    //右边的文字
    rightText: {
      type: String,
      default: ''
    },
    /* 是否显示返回按钮 */
    back: {
      type: Boolean,
      default: true
    },
    /* 是否显示tabbar 不显示时不占用高度 */
    showTabBar: {
      type: Boolean,
      default: true
    },
    //新增，如果父组件存在则调用父组件的返回，不存在则默认返回上一个路由
    backCallback: {
      type: Function,
      require: false
    }
  },
  computed: {
    totalHeight() {
      return this.placeholder
        ? this.showTabBar
          ? this.tabBarHeight + this.statusBarHeight + 'px'
          : this.statusBarHeight + 'px'
        : '0px'
    }
  },
  data() {
    return {
      tabBarHeight: 40,
      statusBarHeight: 20
    }
  },
  created() {
    this.getTabBar()
  },
  methods: {
    async getTabBar() {
      if (!this.$http._isApp()) {
        return
      }
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res) {
        this.tabBarHeight = res.toolsBarHeight
        this.statusBarHeight = res.statusBarHeight
      }
    },
    bindBack() {
      if (this.backCallback) {
        this.backCallback()
      } else {
        this.$http.appBack()
      }
    },
    bindRight() {
      this.$emit('click-right')
    }
  }
}
</script>
<style lang="scss" scoped>
.placeholder {
  width: 100%;
}

.content {
  box-sizing: border-box;
}

.content-fixed {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}

.nav {
  position: relative;
  z-index: 1;
  text-align: center;
  user-select: none;
  display: flex;
  height: 40px;
  align-items: center;

  .nav-bar-left {
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
  }

  .back {
    font-size: 20px;
    font-weight: 600;
  }

  .nav-bar-title {
    flex: 1;
    flex-shrink: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 600;
    padding: 0px 6px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .nav-bar-right {
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
